import React from 'react';
interface CTASectionProps {
  variant?: 'primary' | 'final';
}
export function CTASection({
  variant = 'primary'
}: CTASectionProps) {
  if (variant === 'final') {
    return <div className="my-12 bg-gradient-to-br from-[#1E4D3D] to-[#163a2e] p-8 md:p-12 rounded-xl shadow-2xl text-white" data-id="element-31">
        <h2 className="text-3xl md:text-4xl font-bold mb-6 font-sans" data-id="element-32">
          My Medical Recommendation
        </h2>

        <div className="space-y-4 mb-8 text-white/90 leading-relaxed font-serif" data-id="element-33">
          <p data-id="element-34">
            As a physician who's treated over 2,000 patients struggling with
            nightly drinking, here's what I know:
          </p>

          <p data-id="element-35">
            Your nervous system has been flooded with stress hormones for years.
            Your GABA production is depleted. Your body has been using alcohol
            as the only emergency brake it has left.
          </p>

          <p className="font-bold text-white" data-id="element-36">
            You need biochemical support, not lectures.
          </p>

          <p data-id="element-37">
            The Glisera patch addresses what's actually broken: your
            overstimulated nervous system.
          </p>

          <p data-id="element-38">
            I'm putting the link below if you want to learn more about this
            preparation method. They offer a 60-day guarantee, which from a
            medical standpoint makes sense—it takes time for your nervous system
            to fully regulate.
          </p>

          <p data-id="element-39">
            That's my recommendation as a physician who's seen too many people
            try to fix this with willpower alone.
          </p>
        </div>

        <div className="text-center mb-6" data-id="element-40">
          <p className="text-yellow-300 font-bold text-lg mb-2" data-id="element-41">
            Limited availability — claim your spot now
          </p>
        </div>

        <a href="https://thegliserastore.com/products/glissera-anti-alcohol-patch" className="w-full bg-yellow-400 hover:bg-yellow-300 text-gray-900 font-bold py-5 px-8 rounded-lg shadow-lg transition-all hover:scale-[1.02] text-center text-lg uppercase tracking-wide block" data-id="element-42">
          YES, I WANT TO TRY GLISERA RISK-FREE
        </a>

        <p className="text-center text-white/70 text-sm mt-6" data-id="element-43">
          100% Satisfaction Guarantee | Secure Checkout | Discreet Shipping |
          Made in USA
        </p>
      </div>;
  }
  return <div className="my-12 bg-gray-50 p-6 md:p-8 rounded-xl border border-gray-200" data-id="element-44">
      <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-6 font-sans" data-id="element-45">
        What One Month Could Mean for You
      </h2>

      <p className="text-gray-700 mb-4 leading-relaxed font-serif" data-id="element-46">
        I'm not going to pressure you. But I will tell you what I've seen.
      </p>

      <div className="bg-red-50 border-l-4 border-red-500 p-4 mb-8" data-id="element-47">
        <p className="text-red-800 text-sm md:text-base font-medium" data-id="element-48">
          <span className="font-bold" data-id="element-49">Limited Time:</span> Due to incredibly
          high demand, supply is limited. New inventory sells out within days.
        </p>
      </div>

      <div className="text-center mb-8" data-id="element-50">
        <ul className="text-left space-y-2 max-w-2xl mx-auto text-gray-700 font-serif" data-id="element-51">
          <li data-id="element-52">✓ Keeping the promise you make to yourself in the morning</li>
          <li data-id="element-53">✓ Not questioning whether your drinking is a problem anymore</li>
          <li data-id="element-54">✓ Feeling calm again—not wine-calm, but actually calm</li>
          <li data-id="element-55">✓ Your nervous system working the way it's supposed to</li>
          <li data-id="element-56">✓ Waking up proud instead of ashamed</li>
          <li data-id="element-57">✓ Finally trusting yourself again</li>
        </ul>
      </div>

      <a href="https://thegliserastore.com/products/glissera-anti-alcohol-patch" className="w-full bg-[#1E4D3D] hover:bg-[#163a2e] text-white font-bold py-4 px-6 rounded shadow-lg transition-transform hover:scale-[1.01] text-center text-sm md:text-base uppercase tracking-wide mb-4 block" data-id="element-58">
        CHECK AVAILABILITY NOW
      </a>

      <p className="text-center text-gray-600 text-sm" data-id="element-59">
        60-Day Money-Back Guarantee — If your nervous system doesn't calm down,
        if the urge doesn't quiet, if you don't feel a significant difference,
        return it for a full refund. No questions asked.
      </p>
    </div>;
}